import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../state'
import { NavigationLinkDirective } from '../../navigation-link.directive'

@ngCore.Component({
  imports: [
    ds.illustration.emptyState.Component,
    ds.loader.Component,
    NavigationLinkDirective,
  ],
  selector: 'atn-home-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)
  /** @see {@link state.navigation.Feature} */
  private readonly _navigationFeature = ngCore.inject(state.navigation.Feature)
  /** Angular injector used when scheduling render callbacks from effects. */
  private readonly _injector = ngCore.inject(ngCore.Injector)

  /**
   * List of all apps that have at least one page.
   */
  public readonly appsSg = ngCore.computed(
    (
      apps = this.meFeature.contexts.selectors.availableApps.asSignal(),
      // TODO This is a temporary solution. We should show all apps even if they
      // have no pages. However, we need to create some landing page for empty
      // apps that has no pages assigned to them
    ) => apps.filter(app => app.pages.length > 0),
  )

  /**
   * Reports when home has rendered enough to replace the transition veil.
   */
  private readonly _pageRenderedEffect = ngCore.effect(() => {
    const isLoading = this.meFeature.selectors.isLoading.asSignal()
    const zoneId = this.meFeature.contexts.selectors.zoneId.asSignal()
    const isLoadingApps = zoneId
      ? !this.meFeature.zoneApps.selectors.getResult(zoneId).asSignal()
          .isSettled
      : false

    if (isLoading || isLoadingApps) {
      return
    }

    ngCore.afterNextRender(
      () => {
        this._navigationFeature.actions.pageRendered
          .from('HomePage.Rendered')
          .dispatch()
      },
      { injector: this._injector },
    )
  })

  /** Retries loading the current user's access tree. */
  public refreshAccessBtnClickHandler(): void {
    this.meFeature.actions.get
      .from('HomePage.EmptyState.Buttons.Refresh.Clicked')
      .dispatch()
  }

  /** Retries loading apps for the current zone. */
  public refreshAppsBtnClickHandler(): void {
    const context = this.meFeature.contexts.selectors.zoneContext.asSignal()
    if (context) {
      this.meFeature.zoneApps.actions.get
        .from('HomePage.Apps.Buttons.Refresh.Clicked')
        .dispatch(context)
    }
  }
}
